<template>
    <div class="component-wrap">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-0 py-4': $vuetify.breakpoint.xs,'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'px-2': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <v-breadcrumbs-item :disabled="false">
                        <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                    </v-breadcrumbs-item>
                </v-breadcrumbs>
                <v-layout row wrap align-start
                          mb-4 :class="{'px-3': $vuetify.breakpoint.xs, 'justify-center': $vuetify.breakpoint.smAndDown}"
                >
                    <v-flex md4 sm12>
                        <h1 class="section-title-main my-3 mr-4 font-weight-regular" :class="{'text-xs-center': $vuetify.breakpoint.smAndDown}">{{ $t("Ошибка") }}</h1>
                    </v-flex>
                    <img src="images/404.png" alt="404 error">
                </v-layout>
                <v-layout justify-center align-center class="mb-5">
                    <router-link to="/">
                        <buttonRed>{{ $t("На главную") }}</buttonRed>
                    </router-link>
                </v-layout>
            </v-layout>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import buttonRed   from '@/components/ui/buttons/button_red';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    buttonRed,
  },
};
</script>
